export default __webpack_public_path__ + "static/media/Quiz_00.f21f3b29.png";